import { FormattedMessage } from "react-intl";

import { SelectInput } from "@dzambalaorg/mui-inputs-core";
import { TemplateAssetInput } from "@dzambalaorg/mui-inputs-asset";
import { Alert, FormGrid } from "@dzambalaorg/ui-kit";
import { CraftStatus, ModuleType, TokenType } from "@framework/types";
import { DialogMode } from "@framework/shared";

export interface ICraftDialogFormProps {
  mode: DialogMode;
}

export const CraftDialogForm = (props: ICraftDialogFormProps) => {
  const { mode } = props;

  return (
    <FormGrid columns={mode === "create" ? [1, 1, 1, 1] : [1, 1, 1, 1, 1]}>
      <Alert severity="info" sx={{ mt: 2 }}>
        <FormattedMessage id="alert.craftItem" />
      </Alert>
      <TemplateAssetInput
        required
        autoSelect
        prefix="item"
        contract={{ data: { contractModule: [ModuleType.HIERARCHY] } }}
        tokenType={{ disabledOptions: [TokenType.NATIVE] }}
        multiple
      />
      <Alert severity="info" sx={{ mt: 2 }}>
        <FormattedMessage id="alert.craftPrice" />
      </Alert>
      <TemplateAssetInput
        required
        autoSelect
        prefix="price"
        contract={{ data: { contractModule: [ModuleType.HIERARCHY] } }}
        tokenType={{ disabledOptions: [TokenType.ERC721, TokenType.ERC998] }}
        multiple
      />
      {mode === "edit" && <SelectInput name="craftStatus" options={CraftStatus} />}
    </FormGrid>
  );
};
